import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    BARCODE_CLIPBOARD_FEATURE_KEY,
    BarcodeClipboardState,
    PaceBarcode,
} from '../barcode-clipboard-collection.state';

export const selectBarcodeClipboardFeature =
    createFeatureSelector<BarcodeClipboardState>(BARCODE_CLIPBOARD_FEATURE_KEY);

/** The barcode clipboard, most-recent first, already capped at the retention policy. */
export const selectBarcodeClipboard: MemoizedSelector<object, readonly PaceBarcode[]> = createSelector(
    selectBarcodeClipboardFeature,
    (state) => state.barcodes,
);

/** Raw load status of the slice. */
export const selectBarcodeClipboardStatus: MemoizedSelector<object, LoadStatus> = createSelector(
    selectBarcodeClipboardFeature,
    (state) => state.status,
);

/** Whether the clipboard has been resolved (loaded) from storage at least once. */
export const selectBarcodeClipboardLoaded: MemoizedSelector<object, boolean> = createSelector(
    selectBarcodeClipboardFeature,
    (state) => state.status === LoadStatus.Loaded,
);
